import { ArrowDownLeft, ArrowUpRight } from "lucide-react";
import { fmtAZN } from "@/lib/api";

export const STATUS = {
  pending: ["Gözləyir", "text-amber-400 bg-amber-400/10"],
  approved: ["Təsdiqləndi", "text-emerald-400 bg-emerald-400/10"],
  rejected: ["Rədd edildi", "text-red-400 bg-red-400/10"],
};

export const TxList = ({ txs }) => {
  if (!txs.length) return <p className="text-zinc-500 py-10" data-testid="tx-empty">Hələ əməliyyat yoxdur.</p>;
  return (
    <div className="space-y-3" data-testid="tx-list">
      {txs.map((t) => {
        const [label, cls] = STATUS[t.status];
        const dep = t.type === "deposit";
        return (
          <div key={t.id} className="flex items-center gap-4 rounded-2xl border border-white/10 bg-[#111] px-5 py-4" data-testid={`tx-row-${t.id}`}>
            <div className={`p-2.5 rounded-full ${dep ? "bg-emerald-500/10 text-emerald-400" : "bg-[#D4AF37]/10 text-[#D4AF37]"}`}>
              {dep ? <ArrowDownLeft size={18} /> : <ArrowUpRight size={18} />}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold">{dep ? "Depozit" : "Çıxarış"} · {t.method === "m10" ? "m10" : "Kart"}</p>
              <p className="text-xs text-zinc-500 truncate">{t.account} · {new Date(t.created_at).toLocaleString("az-AZ")}</p>
            </div>
            <span className={`text-xs rounded-full px-3 py-1 ${cls}`}>{label}</span>
            <span className="font-display font-semibold w-28 text-right">{dep ? "+" : "-"}{fmtAZN(t.amount)}</span>
          </div>
        );
      })}
    </div>
  );
};
